import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 835C3AA9-800B-4767-BDED-97FB875B19DF
 * name triforce
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triforce.svg
 * tags
 * - Gaming / RPG 
 */
export const TriforceIcon = createSvgIcon(<><path d="M1.5,21L12,3.5L22.5,21H1.5M12,21L17,12H7L12,21Z" /></>, 'TriforceIcon');
export default TriforceIcon